import type {
  AgentPlatformKey,
  AgentPlatformTypes
} from "@/api/useDeployments.types"

// The demo tenant walks through the cloud connections without kosmos-api,
// which serves them only where AI Discovery is live
export const DEMO_PRE_INSTALL: {
  [P in AgentPlatformKey]: AgentPlatformTypes[P]["preInstall"]
} = {
  agentcore: {
    externalId: "kodem-demo-3f9c2a71",
    kodemAccountId: "123456789012",
    cloudformationTemplate: [
      "# Kodem AgentCore connection (demo)",
      "# A connected tenant downloads the template rendered for its settings here",
      "AWSTemplateFormatVersion: '2010-09-09'",
      "Description: Kodem AgentCore connection (demo)",
      "Resources: {}",
      ""
    ].join("\n"),
    templateVersion: "demo"
  },
  "copilot-studio": {
    issuer: "https://oidc.kodemsecurity.com",
    subject: "tenant:kodem-demo",
    audience: "api://AzureADTokenExchange",
    threatDetectionUrl:
      "https://integrations.kodemsecurity.com/copilot-studio/threat-detection",
    threatDetectionScope: "api://kodem/.default",
    threatDetectionAppId: "1c2d3e4f-5a6b-4c7d-8e9f-0a1b2c3d4e5f"
  }
}
